import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(translate)('requestTimeOut')) + " ", 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(translate)('waitAndTryAgain')), 1)
  ]))
}
}

})